import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';
import {
  AccordionBody,
  AccordionButton,
  AccordionSection,
} from '../AccordionV2/AccordionV2.styles';

export const FooterWrapper = styled.footer`
  border-top: 1px solid ${COLORS3.BLACK_030};
  background-color: ${COLORS3.CLOUD_100};
  max-width: 1920px;
  width: 100%;
  margin: auto;
  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    border-left: 1px solid ${COLORS3.BLACK_030};
    border-right: 1px solid ${COLORS3.BLACK_030};
  }

  ul {
    list-style: none;
    padding: 0;
  }
`;

export const ContentWrapper = styled.div`
  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    border-bottom: 1px solid ${COLORS3.BLACK_030};
  }
`;

export const LinksWrapper = styled.div`
  display: flex;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  ${MEDIA_QUERY.MOBILE_XS} {
    display: flex;
    flex-flow: column-reverse;
  }
`;

export const LeftRailWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 66.66%;
  padding: 60px ${SPACING.LG};

  a {
    color: ${COLORS3.BLACK_075};
    font-size: ${FONT.FONT_SIZE_SMALL};
    font-weight: ${FONT.FONT_WEIGHT_REGULAR};
    text-transform: none;
  }
`;

export const StyledH5 = styled.h5`
  font-family: ${FONT.FONT_FAMILY_NEW_SPIRIT};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  font-size: ${FONT.FONT_SIZE_REGULAR};
  margin-bottom: ${SPACING.S24};
  letter-spacing: normal;
`;

export const StyledLi = styled.li`
  margin-bottom: ${SPACING.XS};
`;

export const StyledHr = styled.hr`
  margin: 0;
  color: ${COLORS3.BLACK_030};
  border: none;
  border-left: 1px solid ${COLORS3.BLACK_030};
`;

export const AccordionWrapper = styled.div`
  color: white;
  padding: 0 ${SPACING.MD};

  ${AccordionSection},
  ${AccordionSection}:first-of-type {
    border-color: ${COLORS3.BLACK_030};
  }

  ${AccordionButton} {
    padding-bottom: ${SPACING.S32};
  }

  ${AccordionBody} {
    padding-bottom: ${SPACING.LG};
  }

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    ${AccordionSection}:first-of-type {
      border-top: none !important;
    }
    ${AccordionSection}:last-of-type {
      border-bottom: none !important;
    }
  }

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    padding-top: ${SPACING.LG};
    padding-bottom: 28px;
  }
`;
